import React, { useState } from 'react';
import './book.css';
import book from './images/bg-title-page-02.jpg';

const Booktable = () => {
  const [formData, setFormData] = useState({
    date: "",
    name: "",
    time: "",
    phone: "",
    people: 1,
    email: ""
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Booking data:", formData);
    alert("Booking submitted!");
    setFormData({ date: "", name: "", time: "", phone: "", people: 1, email: "" });
  };

  return (
    <div className='Table'>
      <section className='hero' style={{ backgroundImage: `url(${book})` }}>
        <div className='hero-content'>
          <h1>BOOK A TABLE</h1>
        </div>
      </section>

      <div className="move">
        <h1><span className='span'>Reservation</span> Book a Table</h1>
      </div>

      <div className="Book-table">
        <form className="date-time" onSubmit={handleSubmit}>
          <div className="input-div">
            <h3>Date</h3>
            <input type="date" name="date" value={formData.date} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>Name</h3>
            <input type="text" name="name" placeholder="Enter name" value={formData.name} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>Time</h3>
            <input type="time" name="time" value={formData.time} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>Phone</h3>
            <input type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} className="input" />
          </div>
          <div className="input-div">
            <h3>People</h3>
            <input type="number" name="people" placeholder="People" value={formData.people} onChange={handleChange} className="input" min="1" />
          </div>
          <div className="input-div">
            <h3>Email</h3>
            <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} className="input" />
          </div>
          <button type="submit" className="book-btn">Book Now</button>
        </form>
      </div>

      <div className='margin'> 
        <div className='book-2'>
          <div className='book-2-1'>
            <h1>Reserve by Phone</h1>
            <p>Donec quis euismod purus. Donec feugiat ligula rhoncus, varius nisl sed, tincidunt lectus. Nulla vulputate, lectus vel volutpat efficitur, orci lacus sodales sem, sit amet quam: <span className='span'>(001) 345 6889</span></p>
          </div>
          <div className='book2-2'>
            <h1>For Event Booking</h1>
            <p>Donec feugiat ligula rhoncus: <span className='span'> (001) 345 6889 </span>, varius nisl sed, tincidunt lectus sodales sem.</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Booktable;
